module.exports = __webpack_public_path__ + "assets/img/role_menpai_name-2813aa18.png";